module.exports = __webpack_public_path__ + "static/media/music-alt.c1eeca0e.svg";